import { createFileRoute } from "@tanstack/react-router";

import { pageTitle } from "@/i18n/title";
import { query } from "@/queries";
import { SupportThreadPage } from "@/supportChats/SupportThreadPage";

export const Route = createFileRoute("/_authed/support/$conversationId")({
  head: () => pageTitle("Support"),
  loader: ({ context: { queryClient }, params }) => {
    const id = params.conversationId;
    void queryClient.query(query.support.thread(id)).catch(() => undefined);
    void queryClient
      .infiniteQuery(query.support.messages(id))
      .catch(() => undefined);
  },
  component: SupportThreadRoute,
});

function SupportThreadRoute() {
  const { conversationId } = Route.useParams();
  return <SupportThreadPage key={conversationId} />;
}
